export const SEND_MENUS = {
    TEXT_BASIC: { path: '/send/text/basic', label: '문자 · 일반문자' },
    TEXT_ELECTION: { path: '/send/text/election', label: '문자 · 선거문자' },
    TEXT_MANUAL: { path: '/send/text/manual', label: '문자 · 20개씩 수동전송' },
    RCS_BASIC: { path: '/send/rcs/basic', label: 'RCS · 일반문자' },
    RCS_ELECTION: { path: '/send/rcs/election', label: 'RCS · 선거문자' },
    RCS_MANUAL: { path: '/send/rcs/manual', label: 'RCS · 20개씩 수동전송' },
}

export const SEND_ACCESS_REQUIRED = 'SEND_ACCESS_REQUIRED'
export const SEND_ACCESS_EVENT = 'send-access-required'

export function sendMenuForPath(pathname) {
    return Object.keys(SEND_MENUS).find(menu => SEND_MENUS[menu].path === pathname.replace(/\/$/, '')) || null
}

export function notifySendAccessRequired(data) {
    if (data?.header?.returnCode !== SEND_ACCESS_REQUIRED || !SEND_MENUS[data.requiredMenu]) return false
    window.dispatchEvent(new CustomEvent(SEND_ACCESS_EVENT, { detail: { menu: data.requiredMenu } }))
    return true
}

export const SEND_ACCESS_RESTORED = 'send-access-restored'

// A business denial must not replace valid RTK Query data with an error envelope.
export function normalizeSendAccessResult(result) {
    const data = result.data || result.error?.data
    if (data?.header?.returnCode !== SEND_ACCESS_REQUIRED) return result
    notifySendAccessRequired(data)
    return { error: { status: 428, data }, meta: result.meta }
}
